<template>
  <div>
    <template v-if="showNewComponents">
      <div :class="$style.statusBadgesContainer">
        <StatusBadge
          v-if="showJitPill"
          :class="$style.statusBadge"
          :icon="isJitPillEnabled ? 'checkmark' : ''"
          :isUppercase="false"
          :status="isJitPillEnabled ? 'success' : 'inactive'"
          text="JIT Provisioning"
        />
        <StatusBadge
          v-if="showScimPill"
          :class="$style.statusBadge"
          :data-test-id="$testId('scimStatusBadge')"
          :icon="isScimActive ? 'checkmark' : ''"
          :isUppercase="false"
          :status="isScimActive ? 'success' : 'inactive'"
          :text="$options.scimPillText"
        />
      </div>
    </template>
    <template v-else>
      <Pill
        v-if="showJitPill"
        :class="{ [$style.pillActive]: isJitPillEnabled }"
        :iconComponent="jitIconComponent"
        text="JIT Provisioning"
      />
      <Pill
        v-if="showScimPill"
        :class="{ [$style.pillActive]: isScimActive }"
        :data-test-id="$testId('scimPill')"
        :iconComponent="showScimCheckIcon"
        :text="$options.scimPillText"
      />
    </template>
  </div>
</template>

<script>
import { StatusBadge } from '@jumpcloud/ui-components';
import { isObject } from 'lodash';
import { mapGetters } from 'vuex';

import { ItemTypeConsts } from 'client/util/Constants';
import { scimPillText } from 'client/util/Constants/ApplicationConstants';
import HardcodedScimSupportMixin from 'client/applications/mixins/HardcodedScimSupportMixin';
import IconCheckmark from 'public/img/icons/icon-checkmark.svg?inline';
import Pill from 'client/components/Buttons/Pill.vue';

export default {
  name: 'ApplicationFeatures',

  components: {
    Pill,
    StatusBadge,
  },

  // This should be removed when the item have SCIM data
  mixins: [HardcodedScimSupportMixin],

  scimPillText,

  props: {
    item: {
      required: true,
      type: Object,
    },
    itemType: {
      type: String,
      default: ItemTypeConsts.application,
    },
    showNewComponents: Boolean,
  },

  data() {
    return {
      IconCheckmark,
    };
  },

  computed: {
    ...mapGetters('FeatureFlagsModule', ['betaFeatures']),

    hardcodedIsScimApp() {
      const { name } = this.item;
      if (this.item.name === 'aws' && this.isScimActive) return true;
      return this.hardcodedIsScimSupported(name);
    },

    isJitPillEnabled() {
      return this.item.sso.jit.enabled;
    },

    isScimActive() {
      const { provision = null } = this.item;
      return provision && !!provision._id;
    },

    isScimSupported() {
      return this.item.provision !== null;
    },

    jitIconComponent() {
      return this.isJitPillEnabled ? IconCheckmark : null;
    },

    showJitPill() {
      if (isObject(this.item.sso.jit) && this.item.sso.jit !== null) {
        return this.item.sso.jit.supported;
      }
      return this.item.sso.jit;
    },

    showScimCheckIcon() {
      return this.isScimActive ? IconCheckmark : null;
    },

    showScimPill() {
      if (!this.item) return false;

      // We are hardcoding scim apps while we get a better understanding
      // about the patterns for SCIM integration accross the different
      // SP. Eventually the item object will have the propper information and
      // only "isScimSupported" will be used.
      const { name } = this.item;

      if (this.hasBetaFeature(name) && !this.isBetaflagActive(name)) return false;

      const isGeneric = this.item.provision ? (this.item.provision.type === 'scim:generic') : false;
      return this.item.provision !== null && (this.hardcodedIsScimApp || isGeneric);
    },
  },
};
</script>

<style module>
@value (pillLight) from '~css/colors.css';

.pillActive {
  background-color: pillLight;
}

.statusBadge:not(:last-of-type) {
  margin-right: 5px;
}

.statusBadgesContainer {
  align-items: center;
  display: flex;
}
</style>
